import { Components } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import { useTheme } from "styled-components";
import { CreatePostModalContext } from "../..";
import { API_CALLS } from "../../../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../../../redux";
import { Loader } from "../../../../../../../Common";
import AudioProps from "./Audio";
import { AudioUploadContainer, ButtonContainer, Container } from "./style";

const AudioUpload = ({ fileInputRef }: AudioProps.IProps) => {
  const { typography } = useTheme();
  const { post_id } = useAppSelector((state) => state.posts);
  const { audio_id, isUploading } = useAppSelector((state) => state.postAudio);
  const { setIsAudioOpen, setPostContentOrder } = useContext(
    CreatePostModalContext
  );

  return (
    <AudioUploadContainer
      onClick={() => fileInputRef?.current?.click()}
      $isUploading={isUploading}
    >
      <Container>
        <Components.IconButton
          kind="Primary"
          size={"Large"}
          disabled={false}
          iconType="Mic"
          onClick={() => {}}
        />
        <Components.Text
          style={{ tokenStyle: typography.Heading["S"] }}
          text="Add Audio"
          fontWeight="font-weight-semibold"
          lineHeight={"line-height-400"}
        />
        <Components.Text
          style={{ tokenStyle: typography.Body["S"] }}
          text="Or drag and drop here"
          fontWeight="font-weight-semibold"
          lineHeight={"line-height-50"}
        />
        <ButtonContainer>
          <Components.IconButton
            disabled={false}
            iconType="X"
            kind="Secondary"
            onClick={(e) => {
              e.stopPropagation();
              API_CALLS.POSTAUDIO.deleteAudioFromAPost({
                post_id,
                audio_id,
              });
              setIsAudioOpen(false);
              setPostContentOrder((prev) =>
                prev.includes("audio")
                  ? prev.filter((item) => item !== "audio")
                  : prev
              );
            }}
            size="Small"
          />
        </ButtonContainer>
      </Container>
      {isUploading && <Loader />}
    </AudioUploadContainer>
  );
};

export default AudioUpload;
